<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col v-if="loginseen" md="8">
            <b-card-group>
              <b-card no-body class="p-4">
                <b-card-body>
                  <form @submit.prevent="appLogin">
                    <h1>Login</h1>
                    <p class="text-muted">Sign In to your account</p>
                    
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Email"
                        autocomplete="phone"
                        v-model="login.email"
                        required
                      />
                    </b-input-group>
                    <b-input-group class="mb-4">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        class="form-control"
                        placeholder="Password"
                        autocomplete="current-password"
                        v-model="login.password"
                        required
                      />
                    </b-input-group>
                    <p v-if="msg" style="color:red;">{{msg}}</p>
                    <b-row>
                      <b-col cols="6">
                        <button
                          type="submit"
                          class="btn btn-info btn-sm btn-block"
                          style="color:white;font-weight:500;"
                        >Login</button>
                      </b-col>
                     <!-- <b-col cols="6">
                        <button
                          type="submit"
                          class="btn btn-warning btn-sm btn-block"
                          style="color:white;font-weight:500;"
                          @click="seen"
                        >Signup</button>
                      </b-col> -->
                    </b-row>
                  </form>
                </b-card-body>
              </b-card>
              <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
                <b-card-body class="text-center">
                  <div>
                     <img src="../../assets/logo.png" height="80%" width="auto" />
                    <p>Tactical Universal Surveillance Knowledge-base System.</p>
                    <!-- <b-button variant="primary" class="active mt-3">Register Now!</b-button> -->
                  </div>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-col>
          <b-col v-else md="8">
            <b-card-group>
              <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
                <b-card-body class="text-center">
                  <div>
                     <img src="../../assets/logo.png" height="80%" width="auto" />
                    <p>Tactical Universal Surveillance Knowledge-base System.</p>
                    <!-- <b-button variant="primary" class="active mt-3">Register Now!</b-button> -->
                  </div>
                </b-card-body>
              </b-card>
              <b-card no-body class="p-4">
                <b-card-body>
                  <!-- <form @submit.prevent="appSignUp"> -->
                    <form>
                    <h1>Sign Up</h1>
                    <!-- <p class="text-muted">Sign In to your account</p> -->
                    
                    <b-input-group class="mb-3 pt-4">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Full Name"
                        autocomplete="phone"
                        v-model="signup.name"
                        required
                      />
                    </b-input-group>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-link"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Email"
                        autocomplete="phone"
                        v-model="signup.email"
                        required
                      />
                    </b-input-group>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-phone"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="text"
                        class="form-control"
                        placeholder="Phone"
                        autocomplete="phone"
                        v-model="signup.phone"
                        required
                      />
                    </b-input-group>
                    <b-input-group class="mb-4">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        class="form-control"
                        placeholder="Password"
                        autocomplete="current-password"
                        v-model="signup.password"
                        required
                      />
                    </b-input-group>
                    <b-input-group class="mb-4">
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        type="password"
                        class="form-control"
                        placeholder="Confirm Password"
                        autocomplete="current-password"
                        v-model="confirmpassword"
                        required
                      />
                    </b-input-group>
                    <p v-if="msg" style="color:red;">{{msg}}</p>
                    <b-row>
                      <b-col cols="6">
                        <button
                          type="submit"
                          class="btn btn-info btn-sm btn-block"
                          style="color:white;font-weight:500;"
                          @click="loginsee"
                        >Login</button>
                      </b-col>
                     <b-col cols="6">
                        <button
                          type="submit"
                          class="btn btn-warning btn-sm btn-block"
                          style="color:white;font-weight:500;"
                          @click="seen"
                        >Signup</button>
                      </b-col>
                    </b-row>
                  </form>
                </b-card-body>
              </b-card>
              
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="col-md-12">
      <!--footer-->
      <a href="#">Tusks | Tactical Universal Surveillance Knowledge-base System.</a>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
      <!-- <b style="float:right;">
        <span class="mr-1">Powered by</span>
        <a href="http://leopardtechlabs.com" target="_blank">Leopard Tech Labs Pvt. Ltd</a>
      </b> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "../../store";
export default {
  name: "login",
  data() {
    return {
      login: {
        email: null,
        password: null,
      },
       signup: {
        name: null,
        email: null,
        phone: null,
        password: null,
        
        
      },
      confirmpassword: null,
      loginseen:true,
      msg: null,
      appLoading: false,
      ServerError: false,
    };
  },
  watch:{
    
    confirmpassword : function(){
     
      if(this.password != this.confirmpassword)
      this.msg = "Password not matching!";
      else
      this.msg = null;
    }
  },
  validators: {
   
    name(value) {
      return this.Validator.value(value).required("Required Field");
    },
    email(value) {
      return this.Validator.value(value).required("Required Field").email();
    },
    phone(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[0-9]*$", "Please Input Valid Number.");
    },
    
  },
  methods: {
    
    appLogin() {
      this.appLoading = true;
      this.msg = null;
      axios({
        method: "POST",
        url: "/user/signin",
        data: this.login,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            // if (
            //   response.data.data.role == "Informant" ||
            //   response.data.data.role == "Subscriber"
            // ) {
            //   this.msg = "You are not authorised to login here";
            //   return;
            // } else {
            //   store.commit("loginUser");
            //   localStorage.setItem("token", response.data.data.token);
            //   localStorage.setItem("role", response.data.data.role);
            //   this.$router.push("/");
            // }
             store.commit("loginUser");
              localStorage.setItem("token", response.data.token);
              localStorage.setItem("role", response.data.role);
              localStorage.setItem("usrType", response.data.usertype);
              this.$router.push("/Reports");
          } else {
            this.msg = response.data.msg;
            return;
          }
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    seen(){
      if(this.loginseen)
      this.loginseen = false;
      else{
         this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.appsignUp();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
      }
    },

    appsignUp(){
        this.appLoading = true;
      this.msg = null;
      axios({
        method: "POST",
        url: "/user/signup",
        data: this.login,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            
             
              this.$router.push("/login");
          } else {
            this.msg = response.data.msg;
            return;
          }
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    loginsee(){
      if(this.loginseen == false)
      this.loginseen = true;
    }
  },
};
</script>
